import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  createDashboardFolder: {
    key: 'dashboard-common-createDashboardFolder',
    defaultValue: 'Criar pasta',
  },
  editDashboardFolder: {
    key: 'dashboard-common-editDashboardFolder',
    defaultValue: 'Editar pasta',
  },
  deleteDashboardFolder: {
    key: 'dashboard-common-deleteDashboardFolder',
    defaultValue: 'Deletar pasta',
  },
  folderName: {
    key: 'dashboard-common-folderName',
    defaultValue: 'Nome da pasta',
  },
})
